import { invokeFunction } from "@/lib/api";

export interface AuditLogEntry {
  id: string;
  actor: string | null;
  action: string;
  target: string | null;
  meta: Record<string, unknown> | null;
  createdAt: string;
}

interface AuditLogRow {
  id: string;
  actor: string | null;
  action: string;
  target: string | null;
  meta: Record<string, unknown> | null;
  created_at: string;
}

function rowToLog(row: AuditLogRow): AuditLogEntry {
  return {
    id: row.id,
    actor: row.actor,
    action: row.action,
    target: row.target,
    meta: row.meta ?? {},
    createdAt: row.created_at,
  };
}

export async function listAuditLogs(): Promise<AuditLogEntry[]> {
  const { logs } = await invokeFunction<{ logs: AuditLogRow[] }>("audit-log", {
    action: "list",
  });
  return logs.map(rowToLog);
}
